import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UserAuthguardGuard  {
  constructor() {

  }
  canActivate() {
    
    return this.isexits();
  }

  async isexits(): Promise<boolean> {
   
    var nb = "";
    var flag = true;
    if(localStorage.getItem("GuestToken") == null || localStorage.getItem("GuestToken") == ''){
        flag = false;
    }
    return flag;
  }
}
